import React, { useEffect } from 'react';

import {
    DocumentEditorContainerComponent, Toolbar
} from '@syncfusion/ej2-react-documenteditor';

import {
    PdfBitmap,
    PdfDocument,
    PdfPageOrientation,
    PdfPageSettings,

    SizeF,
} from '@syncfusion/ej2-pdf-export';

import '@syncfusion/ej2-base/styles/material.css'
import '@syncfusion/ej2-base/styles/material.css';
import '@syncfusion/ej2-buttons/styles/material.css';
import '@syncfusion/ej2-inputs/styles/material.css';
import '@syncfusion/ej2-popups/styles/material.css';
import '@syncfusion/ej2-lists/styles/material.css';
import '@syncfusion/ej2-navigations/styles/material.css';
import '@syncfusion/ej2-splitbuttons/styles/material.css';
import '@syncfusion/ej2-dropdowns/styles/material.css';
import '@syncfusion/ej2-documenteditor/styles/material.css';
import { Button } from '@mui/material';
import useLayoutContext from 'src/hooks/useAuthLayout'
// import confirmSweetAlert from 'src/utils/confirm';
// import useAuth from 'src/hooks/useAuth';
// import { useSnackbar } from 'notistack';
// import { Zoom } from '@mui/material'
// import axios from 'axios';

DocumentEditorContainerComponent.Inject(Toolbar);


function Index() {

    // const {user} = useAuth()
    
    const { modalOpen } = useLayoutContext()
    // const { enqueueSnackbar } = useSnackbar();

    useEffect(() => {
        console.log(modalOpen.item)
    }, [modalOpen]);
    // useEffect(() => {
    //     console.log(pdf1)
    // }, [pdf1])

    let container = DocumentEditorContainerComponent;
    // let contentChanged = false;
    const onClick = async () => {

        let obj = container;
        let pdfdocument = new PdfDocument();
        let count = obj.documentEditor.pageCount;
        obj.documentEditor.documentEditorSettings.printDevicePixelRatio = 2;
        // let loadedPage = 0;

        let bases64 = []
        console.log(count)
        for (let i = 1; i <= count; i++) {
                // let loadedPage2 = loadedPage;
                let format = 'image/jpeg'
                // Getting pages as image
                let image = obj.documentEditor.exportAsImage(i, format);

                image.onload = function () {
                    let imageHeight = parseInt(
                        image.style.height.toString().replace('px', '')
                    );
                    let imageWidth = parseInt(
                        image.style.width.toString().replace('px', '')
                    );
                    let section = pdfdocument.sections.add()
                    let settings = new PdfPageSettings(0);
                    if (imageWidth > imageHeight) {
                        settings.orientation = PdfPageOrientation.Landscape;
                    }
                    settings.size = new SizeF(imageWidth, imageHeight);
                    (section).setPageSettings(settings);
                    let page = section.pages.add();
                    let graphics = page.graphics;
                    let imageStr = image.src.replace('data:image/jpeg;base64,', '');
                    let pdfImage = new PdfBitmap(imageStr);
                    // console.log(pdfImage)
                    graphics.drawImage(pdfImage, 0, 0, imageWidth, imageHeight);
                    // console.log(graphics)
                    // loadedPage+= 1;
                    // if (i === count) {
                    //   // Exporting the document as pdf
                    //   pdfdocument.save(
                    //     (obj.documentEditor.documentName === ''
                    //     ? 'sample'
                    //     : obj.documentEditor.documentName) + '.pdf'
                    //     );
                    //   }
                    // console.log(obj.documentEditor)
                };

                bases64.push(image.src)
        
                console.log(image.src)
                console.log(typeof pdfdocument)
                
            }
            
            console.log(bases64)
            modalOpen.item.setPdf1(bases64)

        modalOpen.item.handleGuardar()
        
    }
    
    

    // const guardarAmbulatorio = () => {
    //     modalOpen.item.handleSubir()
    // }

    return (
        <div style={{ display: "flex", justifyContent: "center", justifyItems: "center", alignContent: "center", alignItems: "center", flexDirection: "column" }}>
            <DocumentEditorContainerComponent id="container" ref={(scope) => { container = scope; }}
                height={'590px'}
                serviceUrl="https://ej2services.syncfusion.com/production/web-services/api/documenteditor/"
                enableToolbar
            />
            <Button variant='contained' style={{ marginTop: "20px", marginBottom: "20px" }} id='export' onClick={() => onClick()}>Guardar Examen</Button>

            {/* {
        pdf1 !== null &&
        <a download="PDF Title" href={`data:image/jpeg;base64,${pdf1}`}>Download PDF document</a>
      } */}

        </div>
    );
}

export default Index;
